export default __webpack_public_path__ + "static/media/mi_filter.a8e38f87.svg";